import { useNavigation } from '@react-navigation/native'
import React from 'react'

import { Page } from 'partials/Page'
import { ResetPasswordForm } from 'partials/ResetPasswordForm'

import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

import { useAuth } from 'hooks/useAuth'

import { links } from 'utils/constants'
import { Toast } from 'utils/toast'

export const ResetPasswordPage = () => {
  const navigation = useNavigation<any>()
  const { resetPassword } = useAuth()
  const { isLoading, error } = resetPassword

  const onSubmit = ({ email }: any) => {
    if (!email) return

    resetPassword.mutateAsync({ email }).then(() => {
      Toast.success('Email sent!', 'Password reset email sent, check your inbox.')
      navigation.navigate(links.LOGIN_PAGE)
    })
  }

  return (
    <Page backgroundColor='black' navigation={navigation}>
      <Box margin='md' padding={{ top: 'xl' }}>
        <Box margin={{ top: 'xl' }} align='center'>
          <Title color='white' bold>
            Forgot password?
          </Title>
          <Box margin={{ top: 'xl', bottom: 'sm' }}>
            <Text fontSize='sm' color='white'>
              Enter your email to receive a reset link
            </Text>
          </Box>
        </Box>
        <ResetPasswordForm loading={isLoading} errors={error} onSubmit={onSubmit} />
      </Box>
    </Page>
  )
}
